import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.title || ""}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {props.children}
      </Modal.Body>
      <Modal.Footer>
        <Button className='bg-dark text-light border-0' onClick={props.postSales}>Post</Button>
        <Button onClick={props.onHide} className="bg-secondary border-0">Cancel</Button>
      </Modal.Footer>
    </Modal>
  );
}

export default MyVerticallyCenteredModal